export default "__VITE_ASSET__7f0b4106__"